import {
  Activity,
  Award,
  BarChart3,
  BookOpen,
  Briefcase,
  CalendarDays,
  ClipboardCheck,
  ClipboardList,
  Coins,
  FileText,
  Flag,
  KeyRound,
  Landmark,
  LayoutDashboard,
  LayoutTemplate,
  ListChecks,
  MessageSquare,
  PenLine,
  Plug,
  Receipt,
  Route,
  ScrollText,
  Settings,
  ShieldCheck,
  Star,
  Users,
  Video,
  Wallet,
} from 'lucide-react';

// Xodim rollari uchun kabinetlar (manba: prototip iifa_prototype_v3.html — ROLES, PAGES).
// Mavjud rollar (super_admin, admin, mentor, student) mantiqi o'zgarmaydi: admin uchun bu yerda faqat
// qo'shimcha "Tizim" sahifalari bor, ular mavjud AdminSidebar'ga qo'shiladi.
//
// Har bir rol: code, name, description, testLogin (faqat telefon — parol hech qayerga yozilmaydi),
// home (kirgandan keyingi sahifa kaliti), groups (sidebar menyusi).
// Sahifa komponentlari — src/roles/pages/<rol>/ (lazy yuklanadi).

const page = (key, label, icon) => ({ key, label, icon });

const DASH = page('dash', 'Bosh sahifa', LayoutDashboard);
const MY_FEES = page('myfees', "Mening hisob-kitoblarim", Wallet);

export const ROLES = {
  director: {
    code: 'director',
    name: 'Direktor',
    description: "Umumiy rahbarlik, byudjet, shartnomalar, hisoblanganlarni tasdiqlash, sifat siyosati",
    testLogin: '+998900000001',
    home: 'dash',
    groups: [
      {
        label: 'Boshqaruv',
        items: [
          DASH,
          page('approvals', 'Tasdiqlashlar', ClipboardCheck),
          page('kpi', "Ko'rsatkichlar", BarChart3),
          page('budget', 'Byudjet', Coins),
          page('contracts', 'Shartnomalar', Briefcase),
          page('controls', 'Nazorat reestri', ShieldCheck),
        ],
      },
    ],
  },
  admin: {
    code: 'admin',
    name: 'Administrator',
    description: "Foydalanuvchilar, integratsiyalar, shablonlar, jurnallar (mavjud admin sahifalariga qo'shimcha)",
    testLogin: '+998900000002',
    home: 'users',
    existing: true,
    groups: [
      {
        label: 'Tizim',
        items: [
          page('users', 'Foydalanuvchilar', Users),
          page('integr', 'Integratsiyalar', Plug),
          page('templates', 'Shablonlar', LayoutTemplate),
          page('logs', 'Jurnal', ScrollText),
        ],
      },
    ],
  },
  head_of_department: {
    code: 'head_of_department',
    name: "Yo'nalish rahbari",
    description: "O'quv rejalar, tasdiqlashlar, o'qituvchilar, sifat ko'rsatkichlari",
    testLogin: '+998900000003',
    home: 'dash',
    groups: [
      {
        label: 'Boshqaruv',
        items: [
          DASH,
          page('programs', 'Dasturlar', BookOpen),
          page('curriculum', "O'quv reja", Route),
          page('pipeline', 'Kurslar tayyorlash jarayoni', Activity),
          page('qcourses', 'Sifat: kurslar', BarChart3),
          page('approvals', 'Tasdiqlash navbati', ClipboardCheck),
          page('instructors', 'Xodimlar', Users),
          page('quality', "Sifat ko'rsatkichlari", Star),
          page('accred', 'Akkreditatsiya hisobotlari', FileText),
        ],
      },
    ],
  },
  registrar: {
    code: 'registrar',
    name: "O'quv bo'limi (registrator)",
    description: "Tinglovchilar reyestri, buyruqlar, transkriptlar, sertifikatlar, apellyatsiyalar",
    testLogin: '+998900000004',
    home: 'dash',
    groups: [
      {
        label: 'Ish',
        items: [
          DASH,
          page('learners', 'Reyestr', Users),
          page('publish', 'Katalog', BookOpen),
          page('stages', "O'quv bosqichlari", Route),
          page('orders', 'Buyruqlar', ScrollText),
          page('transcripts', 'Transkriptlar', ClipboardList),
          page('exams', 'Imtihonlar', ShieldCheck),
          page('certs', 'Sertifikatlar reyestri', Award),
          page('appeals', 'Apellyatsiya', Flag),
          page('cal', 'Taqvim', CalendarDays),
        ],
      },
    ],
  },
  methodist: {
    code: 'methodist',
    name: 'Uslubchi',
    description: "Kurs loyihalarini uslubiy tekshirish, tekshiruv ro'yxatlari, standartlar",
    testLogin: '+998900000005',
    home: 'dash',
    groups: [
      {
        label: 'Ish',
        items: [
          DASH,
          page('queue', 'Tekshiruv navbati', ClipboardCheck),
          page('review', 'Uslubiy tekshiruv', PenLine),
          page('pipeline', 'Kurslar tayyorlash jarayoni', Activity),
          page('standards', 'Uslubiy standartlar', BookOpen),
        ],
      },
      { label: 'Shaxsiy', items: [MY_FEES] },
    ],
  },
  editor: {
    code: 'editor',
    name: 'Tarjimon-muharrir',
    description: 'Til versiyalari, terminologiya, matn sifati',
    testLogin: '+998900000006',
    home: 'dash',
    groups: [
      {
        label: 'Ish',
        items: [
          DASH,
          page('versions', 'Til versiyalari', Route),
          page('langreview', 'Til tekshiruvi', PenLine),
          page('glossary', "Terminlar lug'ati", BookOpen),
        ],
      },
      { label: 'Shaxsiy', items: [MY_FEES] },
    ],
  },
  qc_expert: {
    code: 'qc_expert',
    name: 'Sifat nazorati eksperti',
    description: "Anonim yakuniy tekshiruv, kalibrovka, ishonchlilik reytingi",
    testLogin: '+998900000007',
    home: 'dash',
    groups: [
      {
        label: 'Ish',
        items: [
          DASH,
          page('queue', 'Tekshirish navbati', ClipboardCheck),
          page('review', 'Ekspert tekshiruvi (anonim)', PenLine),
          page('content', 'Kurs tekshiruvi', BookOpen),
          page('history', 'Tarix', ScrollText),
        ],
      },
      {
        label: 'Shaxsiy',
        items: [page('rep', 'Reyting va ishonchlilik', Star), page('settings', 'Sozlamalar', Settings), MY_FEES],
      },
    ],
  },
  proctor: {
    code: 'proctor',
    name: 'Imtihon nazoratchisi (proktor)',
    description: 'Imtihon sessiyalari, shaxsni tasdiqlash, kuzatuv, bayonnomalar',
    testLogin: '+998900000008',
    home: 'dash',
    groups: [
      {
        label: 'Ish',
        items: [
          DASH,
          page('sessions', 'Imtihon sessiyalari', CalendarDays),
          page('live', 'Jonli kuzatuv', Video),
          page('incidents', 'Qoidabuzarlik bayonnomalari', Flag),
        ],
      },
      { label: 'Shaxsiy', items: [MY_FEES] },
    ],
  },
  curator: {
    code: 'curator',
    name: 'Kurator',
    description: "Guruhlar, xavf guruhidagi tinglovchilar, xabarlar, jonli efirlar",
    testLogin: '+998900000009',
    home: 'dash',
    groups: [
      {
        label: 'Ish',
        items: [
          DASH,
          page('cohorts', 'Guruhlarim', Users),
          page('cohort', 'Guruh', Route),
          page('risk', 'Xavf guruhidagi tinglovchilar', Flag),
          page('msgs', 'Xabarlar', MessageSquare),
          page('events', 'Jonli efirlar', Video),
          MY_FEES,
        ],
      },
    ],
  },
  admissions: {
    code: 'admissions',
    name: 'Qabul va sotuv',
    description: "Arizalar, hujjatlar tekshiruvi, lidlar, korporativ bitimlar",
    testLogin: '+998900000010',
    home: 'dash',
    groups: [
      {
        label: 'Ish',
        items: [
          DASH,
          page('apps', 'Arizalar', ClipboardList),
          page('leads', 'Lidlar', Users),
          page('deals', 'Bitimlar', Briefcase),
          page('tasks', 'Vazifalar', ListChecks),
        ],
      },
    ],
  },
  finance: {
    code: 'finance',
    name: 'Moliya',
    description: "To'lovlar, qarzdorlar, hisob-fakturalar, hisobotlar",
    testLogin: '+998900000011',
    home: 'dash',
    groups: [
      {
        label: 'Ish',
        items: [
          DASH,
          page('payments', "To'lovlar", Wallet),
          page('debtors', 'Qarzdorlar', Flag),
          page('invoices', 'Hisob-fakturalar', Receipt),
          page('reports', 'Hisobotlar', BarChart3),
          page('approvals', 'Tasdiqlashlar', ClipboardCheck),
        ],
      },
    ],
  },
  chief_accountant: {
    code: 'chief_accountant',
    name: 'Bosh buxgalter',
    description: "Hisob siyosati, o'tkazmalar, daromadni tan olish, hisobotlar, oy yakuni",
    testLogin: '+998900000012',
    home: 'dash',
    groups: [
      {
        label: 'Ish',
        items: [
          DASH,
          page('journal', "Jurnal-order (o'tkazmalar)", ScrollText),
          page('coa', 'Hisoblar rejasi', ClipboardList),
          page('ar', 'Debitorlik qarzi', Flag),
          page('deferred', 'Kelgusi davr daromadlari', CalendarDays),
          page('payouts', 'Xodimlarga hisoblanganlar', Users),
          page('reports', 'Hisobotlar', BarChart3),
          page('close', 'Oy yakuni', ClipboardCheck),
          page('policy', 'Hisob siyosati', BookOpen),
        ],
      },
    ],
  },
  internal_control: {
    code: 'internal_control',
    name: 'Ichki nazorat',
    description: "Nazorat reestri, vazifalar taqsimoti, sverkalar, istisnolar, audit izi",
    testLogin: '+998900000013',
    home: 'dash',
    groups: [
      {
        label: 'Ish',
        items: [
          DASH,
          page('controls', 'Nazorat reestri', ShieldCheck),
          page('sod', 'Vazifalar taqsimoti', Users),
          page('recon', 'Sverkalar', ClipboardCheck),
          page('exceptions', 'Istisnolar va hodisalar', Flag),
          page('audit', 'Audit izi', ScrollText),
        ],
      },
    ],
  },
  corporate_hr: {
    code: 'corporate_hr',
    name: 'Korporativ mijoz (HR)',
    description: "Xodimlar jarayoni, litsenziyalar, promokodlar, hisob-fakturalar",
    testLogin: '+998900000014',
    home: 'dash',
    groups: [
      {
        label: 'Ish',
        items: [
          DASH,
          page('staff', 'Xodimlar', Users),
          page('seats', 'Litsenziyalar', KeyRound),
          page('billing', 'Hisob-fakturalar', Landmark),
          page('reports', 'Hisobotlar', BarChart3),
        ],
      },
    ],
  },
};

// /cabinets dagi va ko'rish rejimidagi tartib
export const ROLE_ORDER = [
  'director',
  'admin',
  'head_of_department',
  'registrar',
  'methodist',
  'editor',
  'qc_expert',
  'proctor',
  'curator',
  'admissions',
  'finance',
  'chief_accountant',
  'internal_control',
  'corporate_hr',
];

// Yangi rollar (admin — mavjud rol, uning yo'naltirishi va layout'i o'zgarmaydi)
export const NEW_ROLE_CODES = ROLE_ORDER.filter((code) => !ROLES[code].existing);

export const SUPER_ADMIN = 'super_admin';

export const isCabinetRole = (code) => Object.prototype.hasOwnProperty.call(ROLES, code);
export const isNewRole = (code) => NEW_ROLE_CODES.includes(code);

export function rolePages(code) {
  const role = ROLES[code];
  if (!role) return [];
  return role.groups.flatMap((group) => group.items);
}

export function findPage(code, key) {
  return rolePages(code).find((item) => item.key === key) || null;
}

export const cabinetPath = (code, key) => `/cabinet/${code}/${key || ROLES[code]?.home || ''}`;
